export default __webpack_public_path__ + "static/figure3-c4cfa5061ca99e65b266a86cf034df08.webp";